// extracted by css-extract-rspack-plugin
export default {"colorGray9":"#dddddd","searchResult":"user-token-search__searchResult___z6Z3n common__sansSerif___TyY0C","ellipsis":"user-token-search__ellipsis___V17ip common__ellipsis___Iiem0"};